import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-43793d78")

_pushScopeId("data-v-43793d78")
const _hoisted_1 = { class: "menu-item inline-block" }
const _hoisted_2 = { class: "flex align-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "icon el-icon-delete" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "el-icon-circle-plus" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("新建")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_menu_item = _resolveComponent("el-menu-item")
  const _component_el_menu = _resolveComponent("el-menu")
  const _component_el_aside = _resolveComponent("el-aside")
  const _component_radio_menu_detail_table = _resolveComponent("radio-menu-detail-table")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _component_radio_menu_dialog = _resolveComponent("radio-menu-dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_el_container, { class: "padding-20" }, {
      default: _withId(() => [
        _createVNode(_component_el_aside, { width: "240px" }, {
          default: _withId(() => [
            _createVNode(_component_el_menu, {
              class: "el-menu-vertical",
              onSelect: _ctx.selectedMenu
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.radioMenus, (menu) => {
                  return (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: menu.id,
                    index: menu.id
                  }, {
                    title: _withId(() => [
                      _createVNode("div", _hoisted_1, [
                        _createVNode("div", _hoisted_2, [
                          _createVNode("div", null, _toDisplayString(menu.name), 1),
                          _hoisted_3,
                          _createVNode("i", {
                            class: "icon el-icon-edit",
                            onClick: ($event: any) => (_ctx.editMenu(menu))
                          }, null, 8, ["onClick"]),
                          _createVNode(_component_el_popconfirm, {
                            class: "block",
                            onConfirm: ($event: any) => (_ctx.deleteMenu(menu)),
                            title: "确定删除吗？"
                          }, {
                            reference: _withId(() => [
                              _hoisted_4
                            ]),
                            _: 2
                          }, 1032, ["onConfirm"])
                        ])
                      ])
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_el_image, {
                        class: "icon margin-right-10",
                        src: menu.darkIcon
                      }, null, 8, ["src"])
                    ]),
                    _: 2
                  }, 1032, ["index"]))
                }), 128)),
                _createVNode(_component_el_menu_item, {
                  index: "create",
                  onClick: _ctx.addMenu
                }, {
                  title: _withId(() => [
                    _hoisted_6
                  ]),
                  default: _withId(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["onSelect"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_main, null, {
          default: _withId(() => [
            (_ctx.currentMenuId > 0)
              ? (_openBlock(), _createBlock(_component_radio_menu_detail_table, {
                  key: 0,
                  radioMenuId: _ctx.currentMenuId
                }, null, 8, ["radioMenuId"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_radio_menu_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogVisible = $event)),
      menu: _ctx.currentMenuToEdit,
      onSuccess: _ctx.handleMenuUpdate
    }, null, 8, ["modelValue", "menu", "onSuccess"])
  ], 64))
})